import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

var router = new Router({
  mode: 'history',
  // base:process.env.VUE_APP_TITLE == 'uat'?'/cf-trade': '/',
  base: process.env.VUE_APP_NODE_PATH,
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/login',
      component: () => import(/* webpackChunkName: "login" */ '@/view/Login.vue')
    },
    {
      path: '/token',
      component: () => import(/* webpackChunkName: "token" */ '@/components/Token.vue')
    },
    {
      path: '/register',
      component: () => import(/* webpackChunkName: "register" */ '@/view/register/Register.vue')
    },
    {
      path: '/registerNext',
      component: () => import(/* webpackChunkName: "registerNext" */ '@/view/register/RegisterNext.vue')
    },
    {
      path: '/registerResult',
      component: () => import(/* webpackChunkName: "registerResult" */ '@/view/register/RegisterResult.vue')
    },
    {
      path: '/home',
      component: () => import(/* webpackChunkName: "initData" */ '@/view/InitData.vue'),
      meta: {
        keepAlive: true,
        userAuth: true
      },
      children: [
        {
          path: '',
          component: () => import(/* webpackChunkName: "homepage" */ '@/view/Homepage.vue')
        },
        {
          path: 'Turn',
          component: () => import(/* webpackChunkName: "turn" */ '@/view/Turn.vue')
        },
        {
          path: 'OrderHelp',
          component: () => import(/* webpackChunkName: "orderHelp" */ '@/view/OrderHelp.vue')
        },
        {
          path: 'AboutUs',
          component: () => import(/* webpackChunkName: "aboutUs" */ '@/view/AboutUs.vue')
        },
        {
          path: 'WebAPPTutorial',
          component: () => import(/* webpackChunkName: "webAppTutorial" */ '@/view/WebAPPTutorial.vue')
        },
        {
          path: 'Quotation',
          component: () => import(/* webpackChunkName: "quotation" */ '@/view/quotation/Quotation.vue')
        },
        {
          path: 'QuotationView',
          component: () => import(/* webpackChunkName: "quotationView" */ '@/view/quotation/QuotationView.vue')
        },
        {
          path: 'Optional',
          component: () => import(/* webpackChunkName: "optional" */ '@/view/quotation/Optional.vue')
        },
        {
          path: 'QuoteChart',
          component: () => import(/* webpackChunkName: "quoteChart" */ '@/view/quotation/QuoteChart.vue')
        },
        {
          path: 'Attribute',
          component: () => import(/* webpackChunkName: "attribute" */ '@/view/quotation/Attribute.vue')
        },
        {
          path: 'NewsList',
          component: () => import(/* webpackChunkName: "newsList" */ '@/view/news/NewsList.vue'),
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'NewsDetail',
          component: () => import(/* webpackChunkName: "newsDetail" */ '@/view/news/NewsDetail.vue')
        },
        {
          path: 'Trade',
          component: () => import(/* webpackChunkName: "trade" */ '@/view/trade/Trade.vue'),
          meta: {
            userAuth: true
          }
        },
        {
          path: 'PositionChart',
          component: () => import(/* webpackChunkName: "positionChart" */ '@/view/trade/PositionChart.vue'),
          meta: {
            userAuth: true
          }
        },
        {
          path: 'PendingChart',
          component: () => import(/* webpackChunkName: "pendingChart" */ '@/view/trade/PendingChart.vue'),
          meta: {
            userAuth: true
          }
        },
        {
          path: 'SucOrdered',
          component: () => import(/* webpackChunkName: "sucOrdered" */ '@/view/trade/success/SucOrdered.vue'),
          meta: {
            userAuth: true
          }
        },
        {
          path: 'PositionSuc',
          component: () => import(/* webpackChunkName: "positionSuc" */ '@/view/trade/success/PositionSuc.vue'),
          meta: {
            userAuth: true
          }
        },
        {
          path: 'ModifySuc',
          component: () => import(/* webpackChunkName: "modifySuc" */ '@/view/trade/success/ModifySuc.vue'),
          meta: {
            userAuth: true
          }
        },
        {
          path: 'BannerUrl',
          component: () => import(/* webpackChunkName: "bannerUrl" */ '@/view/H5/BannerUrl.vue'),
          meta: {
            serverLink: true
          }
        },
        {
          path: 'LoginUrl',
          component: () => import(/* webpackChunkName: "loginUrl" */ '@/view/H5/LoginUrl.vue'),
          meta: {
            userAuth: true,
            serverLink: true
          }
        },
        {
          path: 'RankList',
          component: () => import(/* webpackChunkName: "rankList" */ '@/view/rankList/RankList.vue')
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  // 访问主页但未登录
  // 访问登录页但已登录过
  if (to.meta.userAuth && !store.state.user.loginname) {
    next({ path: '/login' })
  } else if (
    (to.fullPath.startsWith('/Login') || to.fullPath.startsWith('/login')) &&
    store.state.user.loginname
  ) {
    next({ path: '/home' })
  } else if (
    to.fullPath.startsWith('/home') &&
    to.fullPath.indexOf('Turn') < 0 &&
    store.state.quote.tickList.length == 0
  ) {
    next({ path: '/home/Turn', query: { url: to.fullPath }, replace: true })
  }
  next()
})

export default router